/**
 * @file PlaceholderLogo.jsx
 * @description A placeholder logo component displayed when no company logo is available
 */
import React from 'react';
import { getText } from '../../i18n';

const PlaceholderLogo = ({ width = 200, height = 80, className = '' }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 200 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-label={getText('msg_b90ebfc912ed')}
    >
        <rect
            x="1"
            y="1"
            width="198"
            height="78"
            rx="4"
            fill="white"
            stroke="#E5E7EB"
            strokeWidth="2"
        />
    </svg>
);

export default PlaceholderLogo;
